import {
    CREATE_CUTTING_DC_DETAILS_FAILURE,
    CREATE_CUTTING_DC_DETAILS_REQUEST,
    CREATE_CUTTING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_CUTTING_DC_DETAILS,
    DELETE_CUTTING_DC_DETAILS_FAILURE,
    DELETE_CUTTING_DC_DETAILS_REQUEST,
    DELETE_CUTTING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_FAILURE,
    FETCH_CUTTING_DC_DETAILS_REQUEST,
    FETCH_CUTTING_DC_DETAILS_SUCCESS,
    CUTTING_DC_DETAILS_USERFORM_RESET,
    UPDATE_CUTTING_DC_DETAILS_FAILURE,
    UPDATE_CUTTING_DC_DETAILS_REQUEST,
    UPDATE_CUTTING_DC_DETAILS_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE,
    FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE,
    FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST,
    FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS,
    FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE,
    FETCH_CUTTING_DC_PROGRAM_REQUEST,
    FETCH_CUTTING_DC_PROGRAM_SUCCESS,
    FETCH_CUTTING_DC_PROGRAM_FAILURE,
    FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST,
    FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS,
    FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE,
    FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST,
    FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS,
    FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE,
    CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST,
    CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS,
    CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE,
    CUTTING_DC_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET,
    CUTTING_DC_DETAILS_GENERATE_GRID_FINAL_DATA_SET,
    CREATE_CUTTING_DC_DETAILS_GRID_REQUEST,
    CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS,
    CREATE_CUTTING_DC_DETAILS_GRID_FAILURE,
    RESET_CUTTING_DC_DETAIL_GENERATE_SKU,
    FETCH_CUTTING_DC_DETAILS_FORM_REQUEST,
    FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_FORM_FAILURE,
    FETCH_CUTTING_DC_DETAILS_SIZE_GRID_REQUEST,
    FETCH_CUTTING_DC_DETAILS_SIZE_GRID_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_SIZE_GRID_FAILURE,
    CREATE_USER_FORM_CUTTING_DC_EDIT_QTY,
    CUTTING_EDITABLE_QUANTITY_VALUE_SUCCESS,
    CUTTING_EDITABLE_QUANTITY_VALUE_FALIURE,
    CUTTING_EDITABLE_QUANTITY_VALUE_REQUEST,
    INITAIL_LOADED_GRID_DATA_SIZE,
    CUTTING_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS,
    CUTTING_EDITABLE_INNER_QUANTITY_VALUE_REQUEST,
    CUTTING_EDITABLE_INNER_QUANTITY_VALUE_FALIURE,
    FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_SUCCESS,
    FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_REQUEST,
    FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_FAILURE,
    CUTTING_DC_PROGRAM_ID_SUCCESS,
    CUTTING_DC_PROGRAM_ID_REQUEST,
    CUTTING_DC_PROGRAM_ID_FALIURE,
    CUTTING_DC_DETAILS_DELETE_FABRIC_REQUEST,
    CUTTING_DC_DETAILS_DELETE_FABRIC_SUCCESS,
    CUTTING_DC_DETAILS_DELETE_FABRIC_FAILURE,
    CUTTING_DC_DETAILS_DELETE_FAILURE,
    CUTTING_DC_DETAILS_DELETE_REQUEST,
    RESET_USER_FORM_TO_DEFAULT,
    FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS_RESET,

} from './cuttingDcDetails.actionsType';

export const CUTTING_DC_DETAILS = 'cuttingDCDetails';

let initialState = {
    loading: false,
    cuttingDCDetailsById: [],
    cuttingDCDetailsByInnerGrid: [],
    cuttingDCDetailsForm: [],
    cuttingDCDetails: [],
    cuttingDCDetailsDcNo: [],
    previousList: [],
    cuttingDCDetailsSizeGrid: [],
    grnNoByCuttingDcNo: [],
    cuttingDCProgram: [],
    output: [],
    finalData: [],
    cuttingDCDetailStyle: [],
    generateSKUStyleCuttingDCDetails: [],
    userform: {
        fldFKRatePerPCs: 0,
        // fldFKSKUDetail: [],
        fldQuantity: 0,
        fldFKNoofRolls: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKSKUDetail: []
    },
    selectedCuttingDCDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    editableDcQty: '',
    cuttingDCDetailsSizeGridInitial: [],
    cuttingEditQty: []
};

export let cuttingDCDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    if (type === 'FETCH_CUTTING_DC_DETAILS_SIZE_GRID_SUCCESS') {
        localStorage.setItem('cuttingDCDetailsSizeGridInitial', JSON.stringify(updatePayload));
    }


    switch (type) {
        case FETCH_CUTTING_DC_DETAILS_REQUEST:
        case FETCH_CUTTING_DC_DETAILS_FORM_REQUEST:
        case FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST:
        case FETCH_CUTTING_DC_PROGRAM_REQUEST:
        case FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST:
        case FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST:
        case FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST:
        case FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST:
        case FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST:
        case CREATE_CUTTING_DC_DETAILS_REQUEST:
        case CREATE_CUTTING_DC_DETAILS_GRID_REQUEST:
        case CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST:
        case FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST:
        case UPDATE_CUTTING_DC_DETAILS_REQUEST:
        case DELETE_CUTTING_DC_DETAILS_REQUEST:
        case FETCH_CUTTING_DC_DETAILS_SIZE_GRID_REQUEST:
        case CUTTING_EDITABLE_QUANTITY_VALUE_REQUEST:
        case CUTTING_EDITABLE_INNER_QUANTITY_VALUE_REQUEST:
        case FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_REQUEST:
        case CUTTING_DC_PROGRAM_ID_REQUEST:
        case CUTTING_DC_DETAILS_DELETE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CUTTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCDetails: updatePayload
            };
        case FETCH_CUTTING_DC_DETAILS_SIZE_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsSizeGrid: updatePayload.Program
            };
        case CREATE_USER_FORM_CUTTING_DC_EDIT_QTY:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsSizeGrid: payload
            };
        case INITAIL_LOADED_GRID_DATA_SIZE:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsSizeGridInitial: payload
            }

        case FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsForm: updatePayload
            };
        case FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generateSKUStyleCuttingDCDetails: updatePayload
            };
        case FETCH_CUTTING_DC_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCProgram: updatePayload?.Program
            };
        case FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCDetailStyle: updatePayload?.CUD
            };
        case FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                grnNoByCuttingDcNo: updatePayload?.Inward
            };
        case CUTTING_EDITABLE_QUANTITY_VALUE_SUCCESS:
            return {
                ...state,
                loading: false,
                editableDcQty: updatePayload

            }

        case CUTTING_EDITABLE_INNER_QUANTITY_VALUE_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingEditQty: updatePayload?.Program

            };

        case FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsDcNo: updatePayload?.CUD
            };
        case FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload?.Program
            };
        case FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsById: updatePayload
            };
        case FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsByInnerGrid: updatePayload
            }
        case FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS_RESET:
        case FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                cuttingDCDetailsById: []
            };
        case CREATE_CUTTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                generateSKUStyleCuttingDCDetails: []
            };
        case CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case CUTTING_DC_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fldFkProgramId: updatePayload.fldFKProgram
            }
        case CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                generateSKUStyleCuttingDCDetails: []
            };

        case FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCuttingDCDetails: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_CUTTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCuttingDCDetails: {},
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                }
            };
        case DELETE_CUTTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                selectedCuttingDCDetails: {}
            };

        case FETCH_CUTTING_DC_DETAILS_FAILURE:
        case FETCH_CUTTING_DC_DETAILS_FORM_FAILURE:
        case FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE:
        case FETCH_CUTTING_DC_PROGRAM_FAILURE:
        case FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE:
        case FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE:
        case FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE:
        case FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE:
        case FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE:
        case FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE:
        case CREATE_CUTTING_DC_DETAILS_FAILURE:
        case CREATE_CUTTING_DC_DETAILS_GRID_FAILURE:
        case CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE:
        case UPDATE_CUTTING_DC_DETAILS_FAILURE:
        case DELETE_CUTTING_DC_DETAILS_FAILURE:
        case FETCH_CUTTING_DC_DETAILS_SIZE_GRID_FAILURE:
        case CUTTING_EDITABLE_QUANTITY_VALUE_FALIURE:
        case CUTTING_EDITABLE_INNER_QUANTITY_VALUE_FALIURE:
        case FETCH_CUTTING_DC_DETAILS_BY_INNER_GRID_FAILURE:
        case CUTTING_DC_PROGRAM_ID_FALIURE:
        case CUTTING_DC_DETAILS_DELETE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_CUTTING_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_USER_FORM_TO_DEFAULT:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: [],
                    fldStyleNumber: '',
                    fldSalesOrderNo: '',
                    fldFabricGroup: '',
                    fldFabric: '',
                    fldYarnCounts: '',
                    FldColour: '',
                    fldDia: '',
                    fldReceivingRolls: '',
                    fldQuantity: '',
                    pendingQty: '',
                    fldFinishingGSM: 0
                },
            }
        case CUTTING_DC_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET:
            return {
                ...state,
                loading: false,
                output: payload
            };
        case CUTTING_DC_DETAILS_GENERATE_GRID_FINAL_DATA_SET:
            return {
                ...state,
                loading: false,
                finalData: payload
            };
        case RESET_CUTTING_DC_DETAIL_GENERATE_SKU:
            return {
                ...state,
                loading: false,
                generateSKUStyleCuttingDCDetails: []
            };
        case CUTTING_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldFKRatePerPCs: 0,
                    // fldFKSKUDetail: [],
                    fldQuantity: 0,
                    fldFKNoofRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKSKUDetail: []
                },
                selectedCuttingDCDetails: {}
            };
        default:
            return state;
    }
};
